import { FormFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import React from 'react'
import { useController, useWatch } from 'react-hook-form'
import { cn } from '@/utils/style.ts'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'
import { Input } from 'antd'

type FormTextAreaProps = {
  placeholder?: string
  disabled?: boolean
} & WrappedInputProps

export const FormTextArea: React.FC<FormTextAreaProps> = ({
  name,
  label,
  description,
  placeholder,
  className,
  wrapperClassName,
  disabled,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName })
  const value = useWatch({ name: fieldName }) ?? ''

  return (
    <FormFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      disabled={disabled}
      description={description}
    >
      <Input.TextArea
        className={cn('w-full py-1 px-3 h-8', className)}
        rows={4}
        placeholder={placeholder} {...field}
        value={value}
        disabled={disabled}
      />
    </FormFieldWrapper>
  )
}